import { render, staticRenderFns } from "./CarouselModV2.vue?vue&type=template&id=166149cb"
import script from "./CarouselModV2.vue?vue&type=script&lang=js"
export * from "./CarouselModV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports